export default __webpack_public_path__ + "static/media/superhost-user-key-indicator.47679149.svg";